import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import {
  addVariableToUser,
  removeVariableToUser,
  postEditRange,
  // postAddRange,
  // deleteRange,
} from '../../../../services/api';
import { notifyError, notifySuccess, notifyWarning } from '../../../../utils';
import { Input, EmptyState } from '../../../../components';
import Card from './card-supervisorio';
import { FAMILIES, getVariableFamily } from './variable-family';
import * as s from './styled-cards-supervisorios';

const CardsVariaveis = ({ thingId, thingName, filter, clearFilter }) => {
  const [orderedCards, setOrderedCards] = useState([]);
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(true);
  // Conjunto de familias colapsadas. Inicializa vazio (todas expandidas).
  const [collapsedFamilies, setCollapsedFamilies] = useState(new Set());
  const { variables = [], values = {} } = useSelector(
    (state) => state.iot[thingName] || {}
  );
  const { favorites } = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [favoriteThingVars, setFavoriteThingsVars] = useState([]);

  useEffect(() => {
    let newVars = [];
    favorites.vars.map((thingFav) => {
      if (String(thingFav.id) === String(thingId)) {
        newVars.push(thingFav.variables);
      }
    });

    // eslint-disable-next-line no-unused-expressions
    newVars[0] ? setFavoriteThingsVars(newVars[0]) : null;
  }, [thingId, favorites]);

  useEffect(() => {
    let orderedVariables = [];
    const favoritesId = new Set(favoriteThingVars.map(({ id }) => String(id)));

    variables.forEach((vari) => {
      if (!favoritesId.has(String(vari.id))) {
        orderedVariables.push(vari);
      } else {
        orderedVariables.push({ ...vari, favorite: true });
      }
    });

    if (filter.length) {
      const lc = filter.toLowerCase();
      orderedVariables = orderedVariables.filter(
        ({ name, ihmname }) =>
          (name && name.toLowerCase().includes(lc)) ||
          (ihmname && ihmname.toLowerCase().includes(lc))
      );
    }

    setOrderedCards(orderedVariables);
  }, [favoriteThingVars, filter, variables]);

  // Agrupa em secoes: 'Favoritos' (sempre primeiro) + uma secao por
  // familia (Temperatura, Vibracao, etc). Familia 'outros' so aparece
  // se tiver pelo menos 1 variavel.
  const groups = useMemo(() => {
    const result = [];
    const favorites = orderedCards.filter((v) => v.favorite);
    const nonFavorites = orderedCards.filter((v) => !v.favorite);

    if (favorites.length > 0) {
      result.push({
        key: 'favoritos',
        label: 'Favoritos',
        items: favorites,
        isFavorites: true,
      });
    }

    // Indexa por familia preservando a ordem definida em FAMILIES.
    FAMILIES.forEach(({ key, label }) => {
      const items = nonFavorites.filter((v) => getVariableFamily(v) === key);
      if (items.length > 0) {
        result.push({ key, label, items });
      }
    });

    return result;
  }, [orderedCards]);

  const toggleFamily = (familyKey) => {
    setCollapsedFamilies((prev) => {
      const next = new Set(prev);
      if (next.has(familyKey)) next.delete(familyKey);
      else next.add(familyKey);
      return next;
    });
  };

  const handleAddRange = (variavelId, ranges) => {
    // postAddRange(
    //   parseInt(thingId, 10),
    //   parseInt(variavelId, 10),
    //   ranges
    // )
    //   .then(({ data }) => {
    setOrderedCards(
      orderedCards.map((vari) => {
        if (vari.id === variavelId) {
          ranges.map((rang, index) => {
            if (rang.category === 'NA' && ranges.length > 1) {
              ranges.map((r, index2) => {
                if (r.category === 'N') {
                  rang = r;
                  ranges[index] = r;
                  ranges.splice(index2, 1);
                }
              });
            }
          });
          return {
            ...vari,
            range: ranges,
            proportion: vari.proportion,
          };
        }
        return vari;
      })
    );
    // })
    // .catch((e) => console.log(e));
  };

  const handleDeleteRange = (deletedRange, variavelId) => {
    // deleteRange(
    //   parseInt(rangeId, 10),
    //   parseInt(thingId, 10),
    //   parseInt(variavelId, 10)
    // )
    //   .then(({ data }) => {
    setOrderedCards(
      orderedCards.map((vari) => {
        if (vari.id === variavelId) {
          let ranges = [...vari.range];
          const deletedRange2 = deletedRange.level === 'L' ? 'H' : 'L';
          const index = ranges.findIndex(
            (r) =>
              r.category === deletedRange.category &&
              r.level === deletedRange.level
          );
          ranges.splice(index, 1);
          const index2 = ranges.findIndex(
            (r) =>
              r.category === deletedRange.category && r.level === deletedRange2
          );
          ranges.splice(index2, 1);
          return {
            ...vari,
            range: ranges,
            proportion: vari.proportion,
          };
        }
        return vari;
      })
    );
    // })
    // .catch((e) => console.log(e));
  };

  const saveRanges = (oldRanges, newRange, variableId) => {
    const formatedNewRanges = [];
    oldRanges.forEach((range) => {
      if (range.category[range.level]) {
        formatedNewRanges.push({
          id: parseFloat(range.id),
          min: parseFloat(newRange[range.category][range.level].min),
          max: parseFloat(newRange[range.category][range.level].max),
        });
      } else {
        if (range.category !== 'N' && range.category !== 'NA') {
          formatedNewRanges.push({
            id: parseFloat(range.id),
            min: parseFloat(newRange[range.category][range.level].min),
            max: parseFloat(newRange[range.category][range.level].max),
            category: range.category,
            level: range.level,
          });
        } else {
          formatedNewRanges.push({
            id: parseFloat(range.id),
            min: parseFloat(newRange[range.category].min),
            max: parseFloat(newRange[range.category].max),
            category: range.category,
            level: range.level,
          });
        }
      }
    });
    postEditRange({ ranges: formatedNewRanges, thingId, variableId })
      .then(() => {
        notifySuccess('Range editado com sucesso');
        // setOrderedCards(
        //   orderedCards.map((vari) => {
        //     if (vari.id === variableId) {
        //       return {
        //         ...vari,
        //         range: data.ranges,
        //         proportion: data.proportion,
        //       };
        //     }
        //     return vari;
        //   })
        // );
        dispatch({
          type: 'IOT/SAGA_GET_THING_VARIABLES',
          thingId,
          thingName,
          typeId: 6,
        });
      })
      .catch((error) => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar o range');
      });
  };

  const handleFavorite = (variable) => {
    let newFavorites = [];
    let newVars = [];
    if (
      favoriteThingVars.map(({ id }) => id).includes(variable.id) &&
      favoriteThingVars.length > 1
    ) {
      removeVariableToUser(variable.id, thingId)
        .then(() => {
          newFavorites = favoriteThingVars.filter(
            ({ id }) => id !== variable.id
          );
          newVars = favorites.vars.filter(({ id }) => id !== thingId);
          newVars.push({ id: thingId, variables: newFavorites });
          dispatch({
            type: 'USUARIO/SET_FAVORITE_VARS',
            vars: newVars,
          });
        })
        .catch(() => {
          notifyError('Não foi possível desfavoritar a variável');
        });
    } else if (favoriteThingVars.map(({ id }) => id).includes(variable.id)) {
      notifyWarning('Você precisa ter pelo menos 1 variável favorita');
    } else if (favoriteThingVars.length < 8) {
      addVariableToUser(variable.id, thingId)
        .then(() => {
          newFavorites = [...favoriteThingVars, variable];
          newVars = favorites.vars.filter(({ id }) => id !== thingId);
          newVars.push({ id: thingId, variables: newFavorites });
          dispatch({
            type: 'USUARIO/SET_FAVORITE_VARS',
            vars: newVars,
          });
        })
        .catch(() => {
          notifyError('Não foi possível favoritar a variável');
        });
    } else {
      notifyWarning('Você só pode selecionar 8 variáveis favoritas');
    }
  };

  // Pula pra uma secao de familia (e garante que ela esteja expandida).
  const scrollToFamily = (familyKey) => {
    setCollapsedFamilies((prev) => {
      if (!prev.has(familyKey)) return prev;
      const next = new Set(prev);
      next.delete(familyKey);
      return next;
    });
    // rAF dobrado: espera o re-render expandir a secao antes de rolar.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const el = document.getElementById(`fam-${familyKey}`);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );
  };

  return (
    <>
      {/* Navegacao fixa de categorias: chips pra pular direto a cada secao
          (scroll longo com ~13 familias). Click expande e rola ate a secao. */}
      {groups.length > 1 && (
        <s.FamilyNav>
          {groups.map((group) => (
            <s.FamilyNavChip
              key={group.key}
              type="button"
              $favorites={group.isFavorites}
              onClick={() => scrollToFamily(group.key)}
              title={`Ir para ${group.label}`}
            >
              {group.label}
              <span className="n">{group.items.length}</span>
            </s.FamilyNavChip>
          ))}
        </s.FamilyNav>
      )}
      <s.GroupedContainer>
        {!!filter.length && <s.ClearFilter onClick={clearFilter} />}
        {!orderedCards.length && filter.length ? (
          <EmptyState
            title="Nenhuma variável encontrada"
            description="Ajuste o filtro para visualizar variáveis."
          />
        ) : (
          groups.map((group) => {
            const isCollapsed = collapsedFamilies.has(group.key);
            return (
              <s.FamilySection key={group.key} id={`fam-${group.key}`}>
                <s.FamilyHeader
                  type="button"
                  onClick={() => toggleFamily(group.key)}
                  aria-expanded={!isCollapsed}
                >
                  <s.FamilyChevron $collapsed={isCollapsed}>›</s.FamilyChevron>
                  <s.FamilyLabel $favorites={group.isFavorites}>
                    {group.label}
                  </s.FamilyLabel>
                  <s.FamilyCount>{group.items.length}</s.FamilyCount>
                </s.FamilyHeader>
                {!isCollapsed && (
                  <s.FamilyGrid>
                    {group.items.map((variavel, index) => (
                      <Card
                        key={variavel.id}
                        handleAddRange={handleAddRange}
                        handleDeleteRange={handleDeleteRange}
                        thingName={thingName}
                        thingId={thingId}
                        variavel={variavel}
                        values={values[variavel.ihmname]}
                        favorite={variavel.favorite}
                        handleFavorite={handleFavorite}
                        saveRanges={saveRanges}
                        selected={selected}
                        setSelected={setSelected}
                        index={index}
                      />
                    ))}
                  </s.FamilyGrid>
                )}
              </s.FamilySection>
            );
          })
        )}
      </s.GroupedContainer>
      <Modal
        style={customStyles}
        isOpen={open}
        onRequestClose={() => setOpen(false)}
      >
        <s.Line>
          <span>Histórico</span>
          <Input
            height="20px"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <s.Line style={{ width: 82 }}>
            <s.Tag style={{ marginRight: 10, height: 11 }} color="darkblue" />
            <s.Tag style={{ height: 11 }} color="orange" />
          </s.Line>
        </s.Line>
      </Modal>
    </>
  );
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    height: '70%',
    position: 'absolute',
    display: 'grid',
    gridTemplateRows: '1fr 8fr',
    rowGap: 16,
    borderRadius: 16,
    zIndex: 102,
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    zIndex: 102,
  },
};

export default CardsVariaveis;
